module.exports = __webpack_public_path__ + "static/media/country.2b5d24b3.proto";